import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getRecipeList(postData) {
  try {
    const response = await callPostApi({ url: "product-recipe/list", body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteRecipe(id) {
  try {
    const response = await callDeleteApi({ url: "product-recipe/" + id });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getRecipeRawMaterials(postData) {
  try {
    const response = await callPostApi({ url: "product-recipe/raw-materials/list", body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getRecipeType(postData) {
  try {
    const response = await callPostApi({ url: "product-recipe/types/list", body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getRecipeUnit(postData) {
  try {
    const response = await callPostApi({ url: "product-recipe/units/list", body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addRecipe(postData) {
  try {
    const response = await callPostApi({ url: "product-recipe", body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateRecipe(postData, id) {
  try {
    const response = await callPutApi({ url: "product-recipe/" + id, body: postData });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getRecipeDetail(id) {
  try {
    const response = await callGetApi({ url: "product-recipe/" + id });
    return response;
  } catch (error) {
    throw error;
  }
}

